import { render, staticRenderFns } from "./PxCriterioValorTotal.vue?vue&type=template&id=cb73d5be&"
import script from "./PxCriterioValorTotal.vue?vue&type=script&lang=js&"
export * from "./PxCriterioValorTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports